<template>
    <div class="layout__padding-clear">
        <div class="text__align-center text__colour-teal layout__margin__bottom-25px colour__background__grey-f7f8fa">
            <div class="layout__padding-clear layout__padding-20px">
                <div class="text__colour-teal text__size-45 text__style-bold-700">Email Signatures</div>
            </div>
        </div>

        <div class="layout__padding-clear layout__width-75">
            <div class="component__columns-2 layout__margin-20-0">
                <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/email-sig-720x500.png" class="layout__width-90 layout__padding__bottom-25px">
            </div>
            <div class="component__columns-2 layout__margin-20-0">
                <h3 class="text__colour-teal text__style-bold-900">A great email can go a long way.</h3>

                <div class="text__size-16 layout__padding-20-0 text__line-height-20px">
                    In the property industry, we know that a personal touch can make a big difference. With a personalised email signature, you can be sure that you’re signing off every email in the right way. Uniquely tailored to you and your business, we can design an email signature to spec, promoting every aspect of your business. All with no monthly license fee.
                </div>

                <div class="text__size-16 text__line-height-20px">
                    <div class="text__line-height-2">&ndash; Personal sign-offs</div>
                    <div class="text__line-height-2">&ndash; Contact details</div>
                    <div class="text__line-height-2">&ndash; Awards and affiliations</div>
                    <div class="text__line-height-2">&ndash; Branch location links</div>
                    <div class="text__line-height-2">&ndash; Website and social media links</div>
                </div>

                <div class="layout__padding-20-0">
                    <el-button class="layout__width-200px button-red"
                               v-on:click="contactUs()">Find out more
                    </el-button>
                </div>
            </div>
        </div>

        <div class="layout__padding-20px colour__background__grey-f7f8fa layout__padding-clear layout__overflow-hidden">
            <div class="text__size-30 text__align-center text__colour-teal text__style-bold-900 layout__padding-20px">You may also like</div>

            <div class="layout__width-80 layout__padding-clear">

            <router-link class="link__colour-black" to="/products/digital/microsites">
                <div class="component__product-3">
                    <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/micrositemockup.jpg" class="layout__width-100">
                    <div class="component__product__subtitles">
                        <div>Microsites</div>
                    </div>
                </div>
            </router-link>

            <router-link class="link__colour-black" to="/products/digital/social-media">
                <div class="component__product-3">
                    <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/socialmediamock.jpg" class="layout__width-100">
                    <div class="component__product__subtitles">
                        <div>Social Media</div>
                    </div>
                </div>
            </router-link>

            <router-link class="link__colour-black" to="/products/digital/web-banners">
                <div class="component__product-3">
                    <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/web-banner-720x500.png" class="layout__width-100">
                    <div class="component__product__subtitles">
                        <div>Web Banners</div>
                    </div>
                </div>
            </router-link>
            </div>
        </div>


    </div>

</template>

<script>

    import Router from '../../../router';

    export default {
        name: "ES",
        components: {},
        data() {
            return {}
        },
        created() {
        },
        methods: {
            contactUs() {
                Router.push({
                    name: '/contact'
                });
            }
        }
    };
</script>